import axios from "axios";
import { HEADERS } from "../../../API/UrlAndPaths";
import store from "../../../Redux/store";
import { setKotTokenData } from "./kotTokenDisplaySlice";
import { tokenStatus } from "./util/kotTokenUtil";

export const getTokenDisplayAPI = async (obj) => {
  // let status;
  try {
    console.log('🔍 Token Display API Request:', {
      branchId: obj.body?.branchId,
      deviceId: obj.body?.deviceId,
      deviceIds: obj.body?.deviceIds,
      deviceIdsCount: obj.body?.deviceIds?.length || 0
    });
    const response = await axios.post(
      "pos/tokenDisplayByBranch",
      obj.body,
      HEADERS
    );

      if (response.status === 200) {
        console.log('✅ Token Display API Response:', {
          preparingCount: response.data?.preparing?.length || 0,
          completedCount: response.data?.completed?.length || 0,
          preparing_sample: response.data?.preparing?.[0],
          completed_sample: response.data?.completed?.[0]
        });
        store.dispatch(setKotTokenData(response.data));

       
      }
    
  } catch (error) {
    store.dispatch(
      setKotTokenData(
        store.dispatch(setKotTokenData({ completed: [], preparing: [] }))
      )
    );
    console.log(error);
  }
};
